import * as S from "./PregnantForms/styles";
import CompTextField from "components/CompTextField";
import CompDateField from "components/CompDateField";
import { NisField } from "components/NisField";
import { Grid } from "@mui/material";

const Forms = ({
  isView,
  isEdit,
  beneficiaryData = null,
  register,
  unregister,
  watch,
  setValue,
  errors,
}) => {
  const nis = watch("nis");

  const handleNis = (data) => {
    setValue("name", data.name);
    setValue("responsible_cpf", data.cpf);
    setValue("birth", data.birth);
    setValue("responsiblerg", data.rg);
    setValue("responsibleorgan", data["rg_issuer"]);
    setValue("responsibleuf", data["rg_uf"]);

    setValue("contact_number_one", data["family"]["contact_number_one"]);
    setValue("contact_number_two", data["family"]["contact_number_two"]);
    setValue("street_type", data["family"]["street_type"]);
    setValue("street_name", data["family"]["street_name"]);
    setValue("street_number", data["family"]["street_number"]);
    setValue("complement", data["family"]["complement"]);
    setValue("name_location", data["family"]["name_location"]);
    setValue("city", data["family"]["city"]);
    setValue("updated", data["updated"] ? "Sim" : "Não");
  };

  return (
    <S.Form>
      <Grid container spacing={2}>
        {/* Linha 1 */}
        <Grid item xs={12} sm={4}>
          <NisField
            nis={nis}
            isView={isView}
            isEdit={isEdit}
            apiText={beneficiaryData?.nis}
            benefitNis={beneficiaryData?.nis}
            textLabel="NIS:"
            name="nis"
            register={register}
            unregister={unregister}
            error={errors.nis}
            helperText={errors.nis && errors.nis.message}
            handleNis={handleNis}
            setValue={setValue}
            b_status={beneficiaryData?.b_status}
          />
        </Grid>
        
        <Grid item xs={12} sm={8}>
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.name}
            textLabel="NOME COMPLETO DO RESPONSÁVEL:"
            fromNis={true}
            type="text"
            required
            name="name"
            register={register}
            unregister={unregister}
            error={errors.name}
            helperText={errors.name && errors.name.message}
          />
        </Grid>

        {/* Linha 2 */}
        <Grid item xs={12} sm={8}>
          <CompTextField
            isView={isView}
            fromNis={true}
            apiText={beneficiaryData?.responsible_cpf}
            textLabel="CPF DO RESPONSÁVEL:"
            placeholder="xxx.xxx.xxx-xx"
            required
            name="responsible_cpf"
            register={register}
            unregister={unregister}
            error={errors.responsible_cpf}
            helperText={errors.responsible_cpf && errors.responsible_cpf.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CompDateField
            isView={isView}
            labelText="DATA DE NASCIMENTO:"
            apiText={beneficiaryData?.birth}
            fromNis={true}
            required
            name="birth"
            register={register}
            unregister={unregister}
            error={errors.birth}
            helperText={errors.birth && errors.birth.message}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            fromNis={true}
            apiText={beneficiaryData?.provisional_contact_number}
            textLabel="CELULAR:"
            mask="(99) 9 9999-9999"
            placeholder="(99) 9 9999-9999"
            name="provisional_contact_number"
            register={register}
            unregister={unregister}
            error={errors.provisional_contact_number}
            helperText={errors.provisional_contact_number && errors.provisional_contact_number.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.person?.family?.contact_number_one}
            textLabel="CELULAR: (CadÚnico)"
            placeholder="(99) 9 9999-9999"
            fromNis={true}
            name="contact_number_one"
            register={register}
            unregister={unregister}
            error={errors.contact_number_one}
            helperText={errors.contact_number_one && errors.contact_number_one.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CompTextField
            isView={isView}
            fromNis={true}
            apiText={beneficiaryData?.person?.family?.contact_number_two}
            textLabel="CELULAR SECUNDÁRIO: (CadÚnico)"
            placeholder="(99) 9 9999-9999"
            name="contact_number_two"
            register={register}
            unregister={unregister}
            error={errors.contact_number_two}
            helperText={errors.contact_number_two && errors.contact_number_two.message}
          />
        </Grid>

        {/* Linha 3 */}

        <Grid item xs={12} sm={4}>
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.cns}
            edit={isEdit}
            textLabel="CNS DO RESPONSÁVEL:"
            fromNis={true}
            type="number"
            required
            name="cns"
            register={register}
            unregister={unregister}
            error={errors.cns}
            helperText={errors.cns && errors.cns.message}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <CompTextField
            isView={isView}
            fromNis={true}
            apiText={beneficiaryData?.person?.rg}
            textLabel="RG:"
            name="rg"
            register={register}
            unregister={unregister}
            error={errors.rg}
            helperText={errors.rg && errors.rg.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.person?.rg_issuer}
            textLabel="ÓRGÃO EMISSOR:"
            fromNis={true}
            name="rg_issuer"
            register={register}
            unregister={unregister}
            error={errors.rg_issuer}
            helperText={errors.rg_issuer && errors.rg_issuer.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            fromNis={true}
            apiText={beneficiaryData?.person?.rg_uf}
            textLabel="UF EMISSOR:"
            name="rg_uf"
            register={register}
            unregister={unregister}
            error={errors.rg_uf}
            helperText={errors.rg_uf && errors.rg_uf.message}
          />
        </Grid>
      </Grid>
    </S.Form>
  );
};

export default Forms;
